// @core/api/endpoints/task/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { AddChecklist } from './add_checklist';
import { AddDependency } from './add_dependency';
import { AddTaskWatcher } from './add_task_watcher';
import { AssignEntity } from './assign_entity';
import { AssignTask } from './assign_task';
import { ChangeEntityTaskStatus } from './change_entity_task_status';
import { ChangeTaskStatus } from './change_task_status';
import { CreateContainerConfig } from './create_container_config';
import { CreateCustomFieldDefinition } from './create_custom_field_definition';
import { CreateStatusDefinition } from './create_status_definition';
import { CreateTask } from './create_task';
import { CreateTaskCategory } from './create_task_category';
import { CreateTaskFromTemplate } from './create_task_from_template';
import { CreateTaskNumberingScheme } from './create_task_numbering_scheme';
import { CreateTaskPolicy } from './create_task_policy';
import { CreateTemplate } from './create_template';
import { CreateView } from './create_view';
import { DeleteContainerConfig } from './delete_container_config';
import { DeleteCustomFieldDefinition } from './delete_custom_field_definition';
import { DeleteStatusDefinition } from './delete_status_definition';
import { DeleteTask } from './delete_task';
import { DeleteTaskCategory } from './delete_task_category';
import { DeleteTaskNumberingScheme } from './delete_task_numbering_scheme';
import { DeleteTaskPolicy } from './delete_task_policy';
import { DeleteTaskType } from './delete_task_type';
import { DeleteTemplate } from './delete_template';
import { DeleteTimeEntry } from './delete_time_entry';
import { DeleteView } from './delete_view';
import { GetAssigneeAvailability } from './get_assignee_availability';
import { GetAvailableTransitions } from './get_available_transitions';
import { GetContainerConfig } from './get_container_config';
import { GetContainerConfigByEntity } from './get_container_config_by_entity';
import { GetDependencyGraph } from './get_dependency_graph';
import { GetTask } from './get_task';
import { GetTaskCategory } from './get_task_category';
import { GetTaskCustomFields } from './get_task_custom_fields';
import { GetTaskNumberingScheme } from './get_task_numbering_scheme';
import { GetTaskPolicy } from './get_task_policy';
import { GetTaskPolicyByEntity } from './get_task_policy_by_entity';
import { GetTaskStats } from './get_task_stats';
import { GetTaskType } from './get_task_type';
import { GetTemplate } from './get_template';
import { ListActivity } from './list_activity';
import { ListCustomFieldDefinitions } from './list_custom_field_definitions';
import { ListDependencies } from './list_dependencies';
import { ListEntityActivity } from './list_entity_activity';
import { ListMyTasks } from './list_my_tasks';
import { ListReadyTasks } from './list_ready_tasks';
import { ListScheduledTasks } from './list_scheduled_tasks';
import { ListStatusDefinitions } from './list_status_definitions';
import { ListTaskCategories } from './list_task_categories';
import { ListTaskNumberingSchemes } from './list_task_numbering_schemes';
import { ListTaskPolicies } from './list_task_policies';
import { ListTaskTypes } from './list_task_types';
import { ListTasks } from './list_tasks';
import { ListTasksByParent } from './list_tasks_by_parent';
import { ListTemplates } from './list_templates';
import { ListTimeEntries } from './list_time_entries';
import { ListViews } from './list_views';
import { LogEntityTime } from './log_entity_time';
import { LogTime } from './log_time';
import { RegisterTaskType } from './register_task_type';
import { RemoveDependency } from './remove_dependency';
import { RemoveTaskCustomField } from './remove_task_custom_field';
import { RemoveTaskWatcher } from './remove_task_watcher';
import { RescheduleTask } from './reschedule_task';
import { ResolveTaskContext } from './resolve_task_context';
import { ScheduleTask } from './schedule_task';
import { SetTaskCustomField } from './set_task_custom_field';
import { SuggestTaskSchedule } from './suggest_task_schedule';
import { ToggleChecklistItem } from './toggle_checklist_item';
import { UnassignTask } from './unassign_task';
import { UnscheduleTask } from './unschedule_task';
import { UpdateChecklistItem } from './update_checklist_item';
import { UpdateContainerConfig } from './update_container_config';
import { UpdateCustomFieldDefinition } from './update_custom_field_definition';
import { UpdateStatusDefinition } from './update_status_definition';
import { UpdateTask } from './update_task';
import { UpdateTaskCategory } from './update_task_category';
import { UpdateTaskNumberingScheme } from './update_task_numbering_scheme';
import { UpdateTaskPolicy } from './update_task_policy';
import { UpdateTaskType } from './update_task_type';
import { UpdateTemplate } from './update_template';
import { UpdateView } from './update_view';

// Re-export individual endpoints
export {
  AddChecklist,
  AddDependency,
  AddTaskWatcher,
  AssignEntity,
  AssignTask,
  ChangeEntityTaskStatus,
  ChangeTaskStatus,
  CreateContainerConfig,
  CreateCustomFieldDefinition,
  CreateStatusDefinition,
  CreateTask,
  CreateTaskCategory,
  CreateTaskFromTemplate,
  CreateTaskNumberingScheme,
  CreateTaskPolicy,
  CreateTemplate,
  CreateView,
  DeleteContainerConfig,
  DeleteCustomFieldDefinition,
  DeleteStatusDefinition,
  DeleteTask,
  DeleteTaskCategory,
  DeleteTaskNumberingScheme,
  DeleteTaskPolicy,
  DeleteTaskType,
  DeleteTemplate,
  DeleteTimeEntry,
  DeleteView,
  GetAssigneeAvailability,
  GetAvailableTransitions,
  GetContainerConfig,
  GetContainerConfigByEntity,
  GetDependencyGraph,
  GetTask,
  GetTaskCategory,
  GetTaskCustomFields,
  GetTaskNumberingScheme,
  GetTaskPolicy,
  GetTaskPolicyByEntity,
  GetTaskStats,
  GetTaskType,
  GetTemplate,
  ListActivity,
  ListCustomFieldDefinitions,
  ListDependencies,
  ListEntityActivity,
  ListMyTasks,
  ListReadyTasks,
  ListScheduledTasks,
  ListStatusDefinitions,
  ListTaskCategories,
  ListTaskNumberingSchemes,
  ListTaskPolicies,
  ListTaskTypes,
  ListTasks,
  ListTasksByParent,
  ListTemplates,
  ListTimeEntries,
  ListViews,
  LogEntityTime,
  LogTime,
  RegisterTaskType,
  RemoveDependency,
  RemoveTaskCustomField,
  RemoveTaskWatcher,
  RescheduleTask,
  ResolveTaskContext,
  ScheduleTask,
  SetTaskCustomField,
  SuggestTaskSchedule,
  ToggleChecklistItem,
  UnassignTask,
  UnscheduleTask,
  UpdateChecklistItem,
  UpdateContainerConfig,
  UpdateCustomFieldDefinition,
  UpdateStatusDefinition,
  UpdateTask,
  UpdateTaskCategory,
  UpdateTaskNumberingScheme,
  UpdateTaskPolicy,
  UpdateTaskType,
  UpdateTemplate,
  UpdateView,
};

// Namespace export for convenient usage
export const taskApi = {
  AddChecklist,
  AddDependency,
  AddTaskWatcher,
  AssignEntity,
  AssignTask,
  ChangeEntityTaskStatus,
  ChangeTaskStatus,
  CreateContainerConfig,
  CreateCustomFieldDefinition,
  CreateStatusDefinition,
  CreateTask,
  CreateTaskCategory,
  CreateTaskFromTemplate,
  CreateTaskNumberingScheme,
  CreateTaskPolicy,
  CreateTemplate,
  CreateView,
  DeleteContainerConfig,
  DeleteCustomFieldDefinition,
  DeleteStatusDefinition,
  DeleteTask,
  DeleteTaskCategory,
  DeleteTaskNumberingScheme,
  DeleteTaskPolicy,
  DeleteTaskType,
  DeleteTemplate,
  DeleteTimeEntry,
  DeleteView,
  GetAssigneeAvailability,
  GetAvailableTransitions,
  GetContainerConfig,
  GetContainerConfigByEntity,
  GetDependencyGraph,
  GetTask,
  GetTaskCategory,
  GetTaskCustomFields,
  GetTaskNumberingScheme,
  GetTaskPolicy,
  GetTaskPolicyByEntity,
  GetTaskStats,
  GetTaskType,
  GetTemplate,
  ListActivity,
  ListCustomFieldDefinitions,
  ListDependencies,
  ListEntityActivity,
  ListMyTasks,
  ListReadyTasks,
  ListScheduledTasks,
  ListStatusDefinitions,
  ListTaskCategories,
  ListTaskNumberingSchemes,
  ListTaskPolicies,
  ListTaskTypes,
  ListTasks,
  ListTasksByParent,
  ListTemplates,
  ListTimeEntries,
  ListViews,
  LogEntityTime,
  LogTime,
  RegisterTaskType,
  RemoveDependency,
  RemoveTaskCustomField,
  RemoveTaskWatcher,
  RescheduleTask,
  ResolveTaskContext,
  ScheduleTask,
  SetTaskCustomField,
  SuggestTaskSchedule,
  ToggleChecklistItem,
  UnassignTask,
  UnscheduleTask,
  UpdateChecklistItem,
  UpdateContainerConfig,
  UpdateCustomFieldDefinition,
  UpdateStatusDefinition,
  UpdateTask,
  UpdateTaskCategory,
  UpdateTaskNumberingScheme,
  UpdateTaskPolicy,
  UpdateTaskType,
  UpdateTemplate,
  UpdateView,
};
